<div class="outer-div-container">
    <router-outlet></router-outlet>
</div>
